import { render, staticRenderFns } from "./UpdateTasks.vue?vue&type=template&id=6d9f4833&"
import script from "./UpdateTasks.vue?vue&type=script&lang=js&"
export * from "./UpdateTasks.vue?vue&type=script&lang=js&"
import style0 from "./UpdateTasks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports